import { secondsToHours } from '@/helpers/dateHelper';
import { getContractFromRoleId } from '@/services/contract/contractHelper';
import { Contract } from '@/services/contract/contracts.types';
import { SeverityType, WarningModel } from '@/services/warnings/warningDefinitions';
import { WorkingShift } from '@/types/daily.types';
import { RosterWarningModel, WarningsProps } from '../../../pages/roster/warnings/warnings.types';

export const getRosterMaxShiftDurationWarnings = (
  shift: WorkingShift,
  contracts: Contract[],
  props: WarningsProps
): RosterWarningModel[] => {
  const { strings } = props;

  if (!shift.assignedContractRoleId) return [];

  const contract = getContractFromRoleId(contracts, shift.assignedContractRoleId);
  if (!contract) return [];

  const shiftDuration = secondsToHours((shift?.end ?? 0) - (shift?.start ?? 0));

  const shiftWarnings: WarningModel[] = [];
  if (shiftDuration > contract.maxHoursPerShift) {
    shiftWarnings.push({
      severity: SeverityType.WARNING,
      name: strings.role.invalidRole,
      details: [strings.role.info],
      shiftId: shift.id
    });
  }

  return shiftWarnings;
};
